import { useMemberDetailsQuery } from "@/store/apis/linkApi"
import { useUserQuery } from "@/store/apis/idpApi"

export function useMemberDetails() {
  const {
    data: memberData,
    isFetching: isFetchingMemberData,
    isLoading: isLoadingMemberData,
    isError: isErrorMemberData,
  } = useMemberDetailsQuery()

  const {
    data: userData,
    isFetching: isFetchingUserData,
    isLoading: isLoadingUserData,
    isError: isErrorUserData,
    error: userDataError,
  } = useUserQuery()

  return {
    isFetching: isFetchingMemberData || isFetchingUserData,
    isLoading: isLoadingMemberData || isLoadingUserData,
    isError: isErrorMemberData || isErrorUserData,
    isFetchingUserData,
    userDataError,
    userData,
    memberData,
  }
}
